var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-events d-flex ml-2"},_vm._l((_vm.mainEvents),function(event,i){return _c('div',{key:event.id_event},[_c('div',{staticClass:"pa-2 pl-0"},[_c('MainEventCard',{attrs:{"event":event,"index":i}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }